import React, { useState } from 'react';
import axios from 'axios';

import { baseStyle } from './frontPost';

interface PostStandProps {
  server: string;
}

const style = {
  background: baseStyle.background,
};

export function ITCGPostStand(props: PostStandProps) {
  const [headline, setHeadline] = useState('');
  const [date, setDate] = useState(new Date());

  React.useEffect(() => {
    (async () => {
      const resp = await axios('/posts/category/update', {
        baseURL: props.server,
        timeout: 5000,
      });
      if (!resp.data) return;

      setHeadline(resp.data.posts[0].title);
      setDate(new Date(resp.data.posts[0].created_at));
    })();
  }, []);

  return (
    <>
      <h3>News Stand</h3>
      <a href={'/posts'}>
        <div style={style} className="flex-spaces row col-9 border padding">
          <div className="align-bottom">Builder's Posts</div>
          <h2>{headline}</h2>
          <div className="align-bottom">{date.toLocaleDateString()}</div>
        </div>
      </a>
    </>
  );
}
